// Pure helpers for the HubSpot meetings embed. Kept free of React/Apollo so
// the URL composition and booking-event detection are unit-testable.

export type BookCallPrefill = {
  email: string | null;
  firstName: string | null;
  lastName: string | null;
};

// HubSpot meetings embed: append the standard embed flag and prefill params to
// the AM's base meeting URL. The booked meeting then auto-logs on the
// creator's HubSpot contact (matched by email).
export const buildEmbedUrl = (
  meetingUrl: string,
  prefill: BookCallPrefill,
): string => {
  const url = new URL(meetingUrl);
  url.searchParams.set('embed', 'true');

  if (prefill.email) {
    url.searchParams.set('email', prefill.email);
  }
  if (prefill.firstName) {
    url.searchParams.set('firstName', prefill.firstName);
  }
  if (prefill.lastName) {
    url.searchParams.set('lastName', prefill.lastName);
  }

  return url.toString();
};

// HubSpot's embed posts a window message when a meeting is booked. The event
// shape is `{ meetingBookSucceeded: true }` under a `data` envelope.
export const isMeetingBookedMessage = (data: unknown): boolean => {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const event = data as { meetingBookSucceeded?: unknown };
  return event.meetingBookSucceeded === true;
};
